export const objectToQueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => `${key.toLowerCase()}=${obj[key]}`)
    .join("&");
};
